import {
    salesEstimatesAsin,
    salesEstimatesMarketplace,
    salesEstimatesProductSmallImageUrl,
    salesEstimatesTitle,
} from '../fieldCreators/salesEstimates'

export const SALES_ESTIMATES_SPECIAL_GROUP_BY_COLUMNS = [
    salesEstimatesTitle(),
    salesEstimatesProductSmallImageUrl(),
    salesEstimatesAsin(),
    salesEstimatesMarketplace(),
]
